// src/config/screens.js
// 🎯 مصدر واحد موحّد لكل أسماء الشاشات في النظام (Dashboard, Sidebar, Tracking...)
// أي شاشة جديدة تتضاف هنا فقط، وهتظهر تلقائياً في كل الأماكن اللي بتستورد من هنا.

// 📌 القيم في aliases هنا مأخوذة حرفياً من قيمة screen=".." في @track_activity
// بكل الـ routers بالباك إند (banks.py, containers.py, invoices.py, pi_invoice.py,
// invitation.py, roles.py) — مش تخمين، عشان نضمن تطابق 100% مع اللي بيتسجل فعلياً.
export const SCREENS = [
  {
    key: 'dashboard',
    labelAr: 'لوحة التحكم',
    labelEn: 'Dashboard',
    path: '/VendorsDashboard',
    icon: '📊',
    color: '#ffce4b',
    inSidebar: true,
    children: [
      // المسار /transfer-report ← App.js -> TransferReport.js
      { key: 'bank_transfers_sequence', labelAr: 'تقرير تسلسل التحويلات', labelEn: 'Bank Transfers Sequence Report', path: '/transfer-report' },
      // raw: "all_invoices" ← invoices.py -> get_all_invoices (@track_activity screen="all_invoices")
      // المسار /vendor-invoices/:id ← App.js -> VendorInvoices.js
      { key: 'vendor_invoices', labelAr: 'فواتير الموردين', labelEn: 'Vendor Invoices', path: '/vendor-invoices', aliases: ['all_invoices'] },
    ]
  },
  {
    key: 'ci_invoices',
    labelAr: 'إدخال الفاتورة النهائية',
    labelEn: 'CI Entry',
    path: '/ci-entry',
    icon: '📝',
    color: '#e0748b',
    // raw: "invoices" ← invoices.py -> create/update/delete/restore_invoice + get_invoice_documents
    aliases: ['CI invoices', 'ci invoices', 'invoices'],
    inSidebar: true,
  },
  {
    key: 'pi_invoices',
    labelAr: 'الفاتورة المسبقة',
    labelEn: 'PI Entry',
    path: '/pi-invoice-entry',
    icon: '📄',
    color: '#00758f',
    // raw: "pi invoice entry" (CRUD) و"pi_invoices" (restore) ← pi_invoice.py
    aliases: ['PI invoices', 'pi_invoice', 'pi invoice entry', 'pi_invoices'],
    inSidebar: true,
  },
  {
    key: 'import',
    labelAr: 'الاستيراد',
    labelEn: 'Import',
    path: '/import',
    icon: '📦',
    color: '#804372',
    inSidebar: true,
    children: [
      // raw: "containers" ← containers.py -> create/delete/update/restore_container
      { key: 'containers', labelAr: 'إدارة الحاويات', labelEn: 'Containers', aliases: ['container'] },
      // raw: "container_documents" ← containers_file.py -> upload/delete documents
      { key: 'container_documents', labelAr: 'مستندات الحاوية', labelEn: 'Container Documents', aliases: ['container_documents'] },
      { key: 'vendor_list', labelAr: 'قائمة الموردين', labelEn: 'Vendor List', aliases: ['vendor list'] },
    ]
  },
  {
    key: 'bank_transfers',
    labelAr: 'التحويل البنكي',
    labelEn: 'Bank Transfer',
    path: '/transfer-requests',
    icon: '💸',
    color: '#5e213e',
    aliases: ['bank transfer', 'requests/banks', 'bank transfers', 'bank_transfer'],
    inSidebar: true,
    children: [
      // raw: "swift_files" ← swift.py -> upload/get/update/delete_swift_file
      { key: 'swift_files', labelAr: 'ملفات السويفت', labelEn: 'Swift Files', aliases: ['swift_files'] },
    ]
  },
  {
    key: 'prior_statement',
    labelAr: 'رقم البيان المسبق',
    labelEn: 'Prior Statement',
    path: '/prior-statement',
    icon: '📁',
    color: '#2f4673',
    aliases: ['prior statement', 'manifests', 'manifest', 'pre_manifests', 'pre_manifest'],

    inSidebar: true,
    
  },
  {
    key: 'vendors_summary',
    labelAr: 'ملخص الموردين',
    labelEn: 'Vendors Summary',
    path: '/vendor-summary/1',
    icon: '🏢',
    color: '#1fc1ca',
    // "summary_vendors" شوفناها في السجلات — لسه محتاجين نتأكد مصدرها بالظبط بالباك إند
    aliases: ['vendors summary', 'summary_vendors'],
    inSidebar: true,
    children: [
      {
        key: 'vendor_details',
        labelAr: 'تفاصيل المورد',
        labelEn: 'Vendor Details',
        // المسار /vendor-details/:id ← App.js -> VendorDetails.js
        path: '/vendor-details',
      }
      // ملحوظة: مفيش "Invoice" منفصلة هنا لأن الباك إند بيستخدم نفس القيمة "invoices"
      // لكل من CI Entry وعرض مستندات الفاتورة — فهي بتتسجل تحت ci_invoices فوق.
    ]
  },
  {
    key: 'track',
    labelAr: 'تتبّع',
    labelEn: 'Track',
    path: '/tracking',
    icon: '🔍',
    color: '#cadd64',
    inSidebar: true,
  },
  {
    key: 'vendors_entry',
    labelAr: 'إدخال المورد',
    labelEn: 'Vendor Entry',
    path: '/vendor-management',
    icon: '👤',
    color: '#a1887f',
    // raw: "vendors" ← containers.py -> link_vendor / unlink_vendor
    aliases: ['vendors entry', 'vendors', 'vendor'],
    inSidebar: true,
  },
  {
    key: 'bank_list',
    labelAr: 'قائمة البنوك',
    labelEn: 'Banks List',
    path: '/dashboard/banks',
    icon: '🏛️',
    color: '#90a4ae',
    // raw: "banks" ← banks.py -> create/get_all/update/delete_bank
    aliases: ['bank list', 'banks', 'company-banks', 'company_banks', 'bank'],
    inSidebar: true,
  },
  {
    key: 'digital_archive',
    labelAr: 'الأرشيف الرقمي',
    labelEn: 'Digital Archive',
    path: '/archive',
    icon: '🗄️',
    color: '#1a2e40',
    aliases: ['digital archive', 'archive'],
    inSidebar: true,
  },
  {
    key: 'add_member',
    labelAr: 'إضافة عضو',
    labelEn: 'Add Member',
    path: '/add-member',
    icon: '➕',
    color: '#6d28d9',
    // raw: "invite" ← invitation.py -> invite_user
    aliases: ['invite'],
    inSidebar: true,
  },
  {
    key: 'manage_members',
    labelAr: 'إدارة الأعضاء',
    labelEn: 'Manage Members',
    path: '/manage-members',
    icon: '👥',
    color: '#0f766e',
    // raw: "admin_management" ← invitation.py -> get_all_invitations
    // raw: "members" ← roles.py + user_permissions.py -> get_all_members/delete/update/get_user/custom-permissions
    // raw: "role_permissions" ← roles.py -> update_role_permissions (تعيين صلاحيات دور)
    // raw: "company_members" ← user.py -> get_company_members
    aliases: ['admin_management', 'members', 'role_permissions', 'company_members'],
    inSidebar: true,
  },
  {
    key: 'settings',
    labelAr: 'الإعدادات',
    labelEn: 'Settings',
    path: '/settings',
    icon: '⚙️',
    color: '#475569',
    // raw: "settings" ← company.py -> get_profile_data
    // raw: "update_settings" ← company.py -> update_settings
    // raw: "send_email" ← company.py -> send_email (اختبار البريد)
    // raw: "profile" ← user.py -> get_user_profile / update_profile
    aliases: ['update_settings', 'send_email', 'profile'],
    inSidebar: false, // شاشة شخصية بتتفتح من قائمة البروفايل، مش من السايدبار الرئيسي
  },
  // شاشات إضافية موجودة في اللوجات لكن مش لينكات مباشرة في السايدبار
  
];

// 🔍 بحث تكراري داخل الشجرة (يدعم أي عمق) — يرجع المسار الكامل من الأب للحفيد
const findNode = (nodes, target, parentPath = []) => {
  for (const node of nodes) {
    const path = [...parentPath, node];
    const allKeys = [node.key, ...(node.aliases || [])].map(k => k.toLowerCase());
    if (allKeys.includes(target)) return path;
    if (node.children) {
      const found = findNode(node.children, target, path);
      if (found) return found;
    }
  }
  return null;
};

/** يرجع مصفوفة [الأب, الابن, الحفيد...] لأي شاشة، أو null لو مش موجودة */
export const getScreenPath = (rawKey) => {
  if (!rawKey) return null;
  return findNode(SCREENS, rawKey.toLowerCase().trim());
};

/** الاسم المترجم للشاشة فقط (بدون المسار الكامل) */
export const getScreenName = (rawKey, isAr = true) => {
  if (!rawKey) return '—';
  const path = getScreenPath(rawKey);
  if (!path) return rawKey;
  const node = path[path.length - 1];
  return isAr ? node.labelAr : node.labelEn;
};

/** المسار الكامل كنص جاهز للعرض: "ملخص الموردين ← تفاصيل المورد ← فاتورة" */
export const getScreenBreadcrumb = (rawKey, isAr = true) => {
  const path = getScreenPath(rawKey);
  if (!path) return rawKey || '—';
  return path.map(n => (isAr ? n.labelAr : n.labelEn)).join(isAr ? ' ← ' : ' → ');
};

/** هل الشاشة الخام (rawKey) تنتمي لفرع الشاشة الأب (parentKey)؟ يشمل نفس الشاشة أيضاً */
export const isUnderScreen = (rawKey, parentKey) => {
  const path = getScreenPath(rawKey);
  if (!path) return false;
  return path.some(n => n.key === parentKey);
};

/** هل شاشتين خام (raw) بينتموا لنفس العقدة النهائية؟ (بديل isSameModule القديمة) */
export const isSameScreen = (rawA, rawB) => {
  if (!rawA || !rawB) return false;
  const pathA = getScreenPath(rawA);
  const pathB = getScreenPath(rawB);
  if (!pathA || !pathB) return false;
  return pathA[pathA.length - 1].key === pathB[pathB.length - 1].key;
};

// 🗺️ خريطة مسطّحة (path -> screen key) لتتبّع الصفحات الفعلية (Page View Tracking)
// بتتبنى مرة واحدة من الشجرة، وبتستخدم في App.js لمعرفة أي شاشة المستخدم فاتح دلوقتي
const buildPathMap = (nodes, map = {}) => {
  for (const node of nodes) {
    if (node.path) map[node.path] = node.key;
    if (node.children) buildPathMap(node.children, map);
  }
  return map;
};

const PATH_TO_SCREEN_KEY = buildPathMap(SCREENS);

/** يرجع مفتاح الشاشة (screen key) المطابق لمسار route معيّن، أو null لو المسار مش شاشة معروفة */
export const getScreenKeyFromPath = (pathname) => {
  if (!pathname) return null;
  // تطابق مباشر أولاً (أسرع وأدق)
  if (PATH_TO_SCREEN_KEY[pathname]) return PATH_TO_SCREEN_KEY[pathname];
  // تطابق جزئي للمسارات اللي فيها معرّفات ديناميكية زي /vendor-summary/1 أو /vendor-details/:id
  const match = Object.keys(PATH_TO_SCREEN_KEY).find(
    p => pathname === p || pathname.startsWith(p + '/')
  );
  return match ? PATH_TO_SCREEN_KEY[match] : null;
};
